import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileService } from '../../shared/services/file.service';
import { SharedModule } from '../../shared/shared.module';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-attachments-modal',
  standalone: true,
  imports: [CommonModule,SharedModule,DialogModule],
  templateUrl: './attachments-modal.component.html',
  styleUrls: ['./attachments-modal.component.scss']
})
export class AttachmentsModalComponent {
  @Input() attachmentsData: any;
  @Output() attachmentsPopupVisible = new EventEmitter<boolean>();
  openAttachmentModal: boolean = false;

  constructor(private fileService: FileService) {
  }

  ngOnInit() {
    this.openAttachmentModal = true;
  }
  closeAttachmentsPopup() {
    this.attachmentsPopupVisible.emit(false);
  }
  downloadAttachment = (fileId: string, fileName: string) => {
    this.fileService.downloadFile(fileId).subscribe((response) => {
      const fileUrl = response.fileUri;
      let downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.setAttribute('style', 'display: none');
      downloadLink.href = fileUrl;
      downloadLink.download = fileName;
      downloadLink.target = '_blank';
      downloadLink.click();
      downloadLink.remove();
    })
  }
}
